import { axios, axios2 } from '@/lib/axios';

type Finalize = {
  customer_signature: string;
  lawyer_id: string;
};
export const finalizeLawyer = (data: Finalize) => {
  return axios2.post(`/customer-api/finalize-lawyer`, data);
};

export const finalizeLawyerRequest = (data) => {
  return axios2.post(`/customer-api/finalize-do-it-lawyer`, data);
};
